/**
 * 2022-01-11
 * 其他（更多）产品的模块
 */

import { OtherProductCell } from '..';
import css from './index.module.scss';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import { useGlobal } from '@/utils/useGlobal';

const defaultData = {
    title: 'Other product',
    more: 'View more',
    moreUrl: '/',
    items: [{}, {}, {}],
};
const defaultStyle = {
    navFontSize: '18px',
    navColor: '#000',
    navRightColor: '',
    backColor: '#fff',
    padding: '0',
    margin: '0',
    itemStyle: {},
};
/**
 *
 * @param cssStyle {
 *  navFontSize: 组件内nav部分文字大小 string,
 *  navColor: nav部分文字颜色 string,
 *  backColor: 组件背景色 string,
 *  padding: 组件padding string,
 *  margin: 组件margin string,
 *  navIconUrl: nav部分icon图标地址 string,
 *  itemStyle：参考组件OtherProductCell的cssStyle参数 object
 * }
 *
 * @param data{
 *  title: nav左侧标题文本 string,
 *  more: nav右侧链接文本 string,
 *  moreUrl: nav右侧链接跳转目标 string，
 *  items：参考OtherProductCell的data参数 array
 * }
 */
export default function OtherProductModule({ cssStyle, data = defaultData, useDefaultTitle = true }: any) {
    const { Link, useState, useEffect, useLang } = useGlobal();
    const styles = { ...defaultStyle, ...cssStyle };
    const [resizeHeight, setResizeHeight] = useState(styles?.itemStyle?.titleHeight || 0);
    const dataObj = { ...defaultData, ...data };
    const [maxHeight, setMaxHeight] = useState(0);
    const { t } = useLang('shared');

    // 重新计算文字高度，所有的list中的title行的文字高度以最高项为准，且文字底部对齐（一行文字内容对齐多行文字的最后一行）
    const reSizeHeight = (value: number) => {
        if (value > maxHeight) {
            setMaxHeight(value);
        }
    };

    useEffect(() => {
        setResizeHeight(maxHeight);
    }, [maxHeight]);

    return (
        <div
            className={`${css.otherProductModule} otherProductModule`}
            style={{ padding: styles.padding, margin: styles.margin, background: styles.backColor }}
        >
            <div className="container">
                <div className="subTitleNav" style={{ fontSize: styles.navFontSize, color: styles.navColor }}>
                    <span className="left font-family-semibold">{useDefaultTitle ? t('product.site_details_product_others') : dataObj.title}</span>
                    <Link
                        href={dataObj.moreUrl}
                        ariaLabel={useDefaultTitle ? t('product.site_details_product_view_more') : dataObj.more}
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'view_more',
                            list_name: 'You might also like',
                            button_name: 'view_more',
                        }}
                    >
                        <div className="right font-family-regular" style={{ color: styles.navRightColor || styles.navColor }}>
                            <span className="rightText">{useDefaultTitle ? t('product.site_details_product_view_more') : dataObj.more}</span>
                            <EFArrowDown
                                style={{
                                    fontSize: '12px',
                                    transform: 'rotate(-90deg)',
                                }}
                            />
                        </div>
                    </Link>
                </div>
                <div className="otherList">
                    {dataObj?.items?.map((item: any, i: number) => (
                        <div
                            className="list"
                            key={i}
                            style={{
                                marginLeft: i === 0 ? '0px' : '35px',
                                display: 'inline-block',
                                width: '350px',
                            }}
                        >
                            <OtherProductCell
                                data={{ ...item }}
                                cssStyle={{ ...styles.itemStyle }}
                                deliveryTitleHeight={reSizeHeight}
                                resizeHeight={resizeHeight}
                                useDefaultTitle={useDefaultTitle}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
